/** Local frontend origins. Production destinations come from the Platform database. */
export const developmentProductOrigins: Readonly<Record<string, string>> = {
  PLATFORM: 'http://localhost:3100',
  RESTAURANT: 'http://localhost:3200',
  COSMETICS: 'http://localhost:3600',
};

export function resolveProductUrl(productCode: string, storedUrl: string, development = import.meta.env.DEV): string {
  const origin = development && developmentProductOrigins[productCode];
  if (!origin) return storedUrl;
  const destination = new URL(storedUrl, origin);
  // Keep business paths, query parameters and fragments supplied by the API.
  return `${origin}${destination.pathname}${destination.search}${destination.hash}`;
}
